// extracted by mini-css-extract-plugin
export var searchHeader = "_7h-0";
export var searchHeaderDark = "_7h-1";